import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoadMeetings from '../loaders/LoadMeetings';
import EventCreateMeeting from '../screens/EventCreateMeeting';
import EventMeetingsByDate from '../screens/Meetings/EventMeetingsByDate/EventMeetingsByDate';
import EventMeetingsTabbed from '../screens/Meetings/EventMeetingsTabbed/EventMeetingsTabbed';
import EventUserAvailability from '../screens/Meetings/EventUserAvailability';
import EventUserMeetingRejection from '../screens/Meetings/EventUserMeetingRejection/EventUserMeetingRejection';
import EventUserMeetingsDefaultTab from '../screens/Meetings/EventUserMeetingsDefaultTab/EventUserMeetingsDefaultTab';
import InviteToMeetingScreen from '../screens/Meetings/InviteToMeetingScreen';
import MeetingDetailsScreen from '../screens/Meetings/MeetingDetailsScreen/MeetingDetailsScreen';
import ErrorBoundary from '../validate/ErrorBoundary';
import HasData from '../validate/HasData';
import WaitWhileBusy from '../WaitWhileBusy';
import chatRoutes from './chatRoutes';
import participantsRoutes, { innerParticipantRoutes } from './participantsRoutes';
import { RouteDateValidation } from './RouteDateValidation';
import {scheduleItemRoutes}  from './scheduleRoutes';
import startNetworkingRoutes from './startNetworkingRoutes';
import HasMeeting from '../validate/HasMeeting';

const speeddateRoutes = (props) => (
    <Switch>
        {/* <Route path={`${props.match.path}/speakers/:speakerId`} exact component={EventSpeakerProfile} />
        <Route path={`${props.match.path}/speakers/:speakerId/invite`} exact component={InviteToMeetingScreen} /> */}
        {/* <Route path={`${props.match.path}/participants`} component={participantsRoutes} /> */}
        <Route path={`${props.match.path}`} component={scheduleItemRoutes} />
    </Switch>
);

export const createMeetingRoutes = (props) => (
    <Switch>
        <Route path={`${props.match.path}/participants`} component={participantsRoutes} />
        <Route path={`${props.match.path}/speeddate/:itemId`} component={speeddateRoutes} />
        <Route path={`${props.match.path}`} exact component={EventCreateMeeting} />
        <Redirect to={props.match.path} />
    </Switch>
);

export const meetingRoutes = (props) => (
    <WaitWhileBusy>
        <HasMeeting eventId={props.match.params.eventId} meetingId={props.match.params.meetingId}>
            <Switch>
                <Route path={`${props.match.path}/participants`} component={innerParticipantRoutes} />
                <Route path={`${props.match.path}/reschedule`} component={InviteToMeetingScreen} />
                <Route path={`${props.match.path}/reject`} component={EventUserMeetingRejection} />
                <Redirect from={`${props.match.path}/chats`} exact to={`${props.match.path}`} />
                <Route path={`${props.match.path}/chats`} component={chatRoutes} />
                <Route path={`${props.match.path}`} exact component={MeetingDetailsScreen} />
                <Redirect to={props.match.path} />
            </Switch>
        </HasMeeting>
    </WaitWhileBusy>
);

const dateMeetingRoutes = (props) => {
    return (
        <RouteDateValidation {...props}>
            <Switch>
                <Route path={`${props.match.path}/availability`} component={EventUserAvailability} />
                <Route path={`${props.match.path}/create`} component={createMeetingRoutes} />
                <Route path={`${props.match.path}/start-networking`} component={startNetworkingRoutes} />
                <Route path={`${props.match.path}/:meetingId`} component={meetingRoutes} />
                <Route path={`${props.match.path}`} component={EventMeetingsByDate} />
            </Switch>
        </RouteDateValidation>
    );
};

const tabMeetingRoutes = (props) => {
    const { meetingTab } = props.match.params,
        isDate = meetingTab.match(/\d{8}/);

    return (
        <Switch>
            <Route path={`${props.match.path}/availability`} component={EventUserAvailability} />
            <Route path={`${props.match.path}/create`} component={createMeetingRoutes} />
            <Route path={`${props.match.path}/start-networking`} component={startNetworkingRoutes} />
            <Route path={`${props.match.path}/:meetingId`} component={meetingRoutes} />
            <Route path={`${props.match.path}`} exact component={isDate ? EventMeetingsByDate : EventMeetingsTabbed} />
        </Switch>
    );
};

export default (props) => (
    <ErrorBoundary altRoute={`../..`}>
        <LoadMeetings eventId={props.match.params.eventId}>
            <HasData path={`events[${props.match.params.eventId}].meetings.loaded`}>
                <Switch>
                    <Route path={`${props.match.path}/create`} component={createMeetingRoutes} />
                    <Route path={`${props.match.path}/availability`} component={EventUserAvailability} />
                    <Route path={`${props.match.path}/start-networking`} component={startNetworkingRoutes} />
                    <Route path={`${props.match.path}/:meetingTab`} component={tabMeetingRoutes} />
                    <Route path={`${props.match.path}`} component={EventUserMeetingsDefaultTab} />
                </Switch>
            </HasData>
        </LoadMeetings>
    </ErrorBoundary>
);
